let ctx = null;

export const unlockAudio = () => {
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
  } catch { /* no audio */ }
  if ("Notification" in window && Notification.permission === "default") Notification.requestPermission().catch(() => {});
};

export const audioReady = () => !!ctx && ctx.state === "running";

// Loud rising/falling siren: 4 sweeps, ~2.4 s.
export const playSiren = () => {
  if (!audioReady()) return;
  const t0 = ctx.currentTime;
  const gain = ctx.createGain();
  gain.gain.setValueAtTime(0.0001, t0);
  gain.gain.exponentialRampToValueAtTime(0.9, t0 + 0.05);
  gain.gain.setValueAtTime(0.9, t0 + 2.3);
  gain.gain.exponentialRampToValueAtTime(0.0001, t0 + 2.45);
  gain.connect(ctx.destination);
  ["sawtooth", "square"].forEach((type, i) => {
    const o = ctx.createOscillator();
    o.type = type;
    for (let k = 0; k < 4; k++) {
      o.frequency.setValueAtTime(650 + i * 7, t0 + k * 0.6);
      o.frequency.linearRampToValueAtTime(1500 + i * 7, t0 + k * 0.6 + 0.3);
      o.frequency.linearRampToValueAtTime(650 + i * 7, t0 + k * 0.6 + 0.6);
    }
    o.connect(gain);
    o.start(t0);
    o.stop(t0 + 2.5);
  });
};
